import { Group, SimpleGrid, Stack } from '@mantine/core'
import React from 'react'
import { themeCfg } from '../../theme/theme'

interface CustomProps
  extends React.ComponentPropsWithoutRef<typeof SimpleGrid> {
  cols?: number
  breakpoint?: string
  bg?: string
  children?: React.ReactNode
}

const AppSimpleGrid = ({
  cols = 4,
  breakpoint = 'md',
  bg,
  children,
  ...otherProps
}: CustomProps) => {
  return (
    <SimpleGrid {...otherProps} bg={bg} cols={{ base: 1, [breakpoint]: cols }}>
      {children}
    </SimpleGrid>
  )
}

export default AppSimpleGrid
